/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import Header from "../layout/header"
import Footer from "../layout/footer"
import "./layout.css"

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
        header: wordpressWpElgatTemplate(slug: { eq: "header" }) {
          slug
          content
          wordpress_id
        }
        footer: wordpressWpElgatTemplate(slug: { eq: "footer" }) {
          slug
          content
          wordpress_id
        }
      }
    `}
    render={data => {
      console.log(data);
      
      return (
      <>
        <Header siteTitle={data.site.siteMetadata.title} template={data.header} />
          <main>{children}</main>
        <Footer template={data.footer} />
      </>
    )}}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
